var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.83796 20.8765C8.64889 19.9478 7.6858 18.7616 7.02108 17.4072C6.35636 16.0527 6.00731 14.5652 6.00015 13.0565C5.9702 7.6362 10.34 3.13044 15.7589 3.0029C17.8587 2.95234 19.9212 3.56423 21.6537 4.75179C23.3862 5.93934 24.7008 7.64226 25.411 9.61899C26.1212 11.5957 26.191 13.7459 25.6104 15.7645C25.0299 17.7831 23.8284 19.5677 22.1766 20.8651C21.8127 21.147 21.5178 21.5079 21.3139 21.9205C21.1101 22.3332 21.0028 22.7868 21 23.247L21 24.0001C21 24.2653 20.8947 24.5196 20.7071 24.7072C20.5196 24.8947 20.2652 25.0001 20 25.0001H12C11.7348 25.0001 11.4804 24.8947 11.2929 24.7072C11.1053 24.5196 11 24.2653 11 24.0001L11 23.2462C10.9988 22.7889 10.8936 22.3379 10.6923 21.9273C10.491 21.5167 10.1988 21.1574 9.83796 20.8765V20.8765Z",
    fill: "#4C7889"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H21",
    stroke: "#4C7889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25V18",
    stroke: "#4C7889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14L16 18L20 14",
    stroke: "#4C7889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83796 20.8765C8.64889 19.9478 7.6858 18.7616 7.02108 17.4072C6.35636 16.0527 6.00731 14.5652 6.00015 13.0565C5.9702 7.6362 10.34 3.13044 15.7589 3.0029C17.8587 2.95234 19.9212 3.56423 21.6537 4.75179C23.3862 5.93934 24.7008 7.64226 25.411 9.61899C26.1212 11.5957 26.191 13.7459 25.6104 15.7645C25.0299 17.7831 23.8284 19.5677 22.1766 20.8651C21.8127 21.147 21.5178 21.5079 21.3139 21.9205C21.1101 22.3332 21.0028 22.7868 21 23.247L21 24.0001C21 24.2653 20.8947 24.5196 20.7071 24.7072C20.5196 24.8947 20.2652 25.0001 20 25.0001H12C11.7348 25.0001 11.4804 24.8947 11.2929 24.7072C11.1053 24.5196 11 24.2653 11 24.0001L11 23.2462C10.9988 22.7889 10.8936 22.3379 10.6923 21.9273C10.491 21.5167 10.1988 21.1574 9.83796 20.8765V20.8765Z",
    stroke: "#4C7889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/Standard.90ea1e6d9a4745a91a2b388a4afe6e69.svg";
export { ForwardRef as ReactComponent };